import type {
  CollectionsCollectionUpdateRequest,
  CollectionsCreateCollectionRequest,
  CollectionsSignCollectionResponse,
} from '@customerio/hydra-ui-api';
import type { SignResponse } from '@/services/uploads';

export type ImportSource =
  | { kind: 's3'; s3Import: string; filename: string }
  | {
      kind: 'sheet';
      sheet: { sheet_id: number; sheet_name: string; spreadsheet_id: string; spreadsheet_name: string };
    };

type CreateBody = CollectionsCreateCollectionRequest['collection'];

export function buildCreateCollectionBody(name: string, description: string, source: ImportSource): CreateBody {
  if (source.kind === 's3') {
    return { name, description, s3_import: source.s3Import };
  }
  // Create accepts only sheet_id + spreadsheet_id; the name fields are dropped.
  return {
    name,
    description,
    sheet: { sheet_id: source.sheet.sheet_id, spreadsheet_id: source.sheet.spreadsheet_id },
  };
}

export function buildUpdateCollectionRequest(source: ImportSource): CollectionsCollectionUpdateRequest {
  if (source.kind === 's3') {
    return { update_type: 's3_import', s3_import: source.s3Import };
  }
  return { update_type: 'sheet', sheet: source.sheet };
}

// Map the generated (all-optional) sign response onto the uploader's concrete
// signature types. The backend always populates these fields for a chosen
// provider; the fallbacks keep the mapping total.
export function toSignResponse(sign: CollectionsSignCollectionResponse, contentType: string): SignResponse {
  if (sign.gcs != null) {
    return { gcs: { url: sign.gcs.url ?? '', fields: sign.gcs.fields ?? {} } };
  }
  const s3 = sign.s3 ?? {};
  return {
    s3: {
      bucket: s3.bucket ?? '',
      acl: s3.acl ?? '',
      awsaccesskeyid: s3.awsaccesskeyid ?? '',
      expires: s3.expires ?? '',
      key: s3.key ?? '',
      policy: s3.policy ?? '',
      signature: s3.signature ?? '',
      success_action_status: s3.success_action_status ?? '',
      'Content-Type': contentType,
    },
  };
}
